export default __webpack_public_path__ + "static/media/hummus_carrot.2ed447e2.jpg";